module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.2809/js/img/bottom-blob.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/bottom-blob.svg
// module id = 734
// module chunks = 3 4